export const env = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:4000',
  VERSION: '/v1',
};

export const workSpaceEnvironnement = process.env.NODE_ENV || 'development'; 